import React from "react";
import { Container } from "@mui/material";
import RoutesRelogio from "./Routes";

function App() {
  return (
    <Container maxWidth="lg" sx={{ padding: "30px" }}>
      <RoutesRelogio />
    </Container>
  );
}

export default App;
